/* app/js/src/components/calendar/calendar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
header {
  padding-bottom: 6px;
}
icn-calendar-grid {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.permission-overlay {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.2;
  position: absolute;
  float: left;
  z-index: 2;
  cursor: not-allowed;
}
/*# sourceMappingURL=calendar.component.css.map */
